import React from 'react';


class AddShop extends React.Component{


  constructor(props){
   super(props)
   this.state={
       name:""
   }
  }


  render(){

    return(
        <div>这是添加商品详情</div>
    )
  }
}

export default AddShop;


// WEBPACK FOOTER //
// ./src/components/Shop/AddShop.js